var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9c17e1db79b7916a107643bf882d9168.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f91ef6b1b7b8afcaf8df9b55f3ffa571.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    